import createDocumentResource, { handleStandardErrors } from 'src/actions/shared/createDocumentResource';
import generateId from 'src/lib/generateId';
import { Answer } from 'src/models/Answers/AnswerModel';
import { AnswerSearchQueryFilter } from 'src/actions/searchDropdown/searchDropdownResource';
import { AppThunk } from 'src/actions/shared/sharedTypes';

type SearchResult = Array<Answer>;

function fetchSuccess(state, { payload }) {
  const hits = payload.hits || [];
  state.loadingState = 'succeeded';
  state.value = hits;
}

interface AnswerSearchQuery {
  language: string;
  text: string;
  audienceId: string;
  filter: AnswerSearchQueryFilter;
}

const request: AppThunk =
  ({ language, text, filter }: AnswerSearchQuery) =>
  (dispatch, getState, { gateways }) => {
    const { fetchStarted } = answerSearchResource.actions;

    const id = generateId();
    const languages = language ? [language] : [];
    const params = { query: { languages, text, filter } };

    dispatch(fetchStarted({}));
    // this gateway is configured with an observer rather returning a promise
    gateways.answerSearch.request(id, params);
  };

const observerCreator = ({ actions }) => {
  const { fetchError, fetchRequestError, fetchSuccess } = actions;

  return ({ dispatch }) => ({
    onFetchSuccess(payload) {
      dispatch(fetchSuccess(payload));
    },
    onFetchError(error) {
      handleStandardErrors({ error, dispatch, handleDomainError: fetchError, handleDefaultError: fetchRequestError });
    },
  });
};

const answerSearchResource = createDocumentResource<SearchResult>({
  name: 'answerSearch',
  endpoint: 'v1/orgs/:orgId/search/snippets',
  initialValue: [],
  effects: {
    request,
  },
  reducers: {
    fetchSuccess,
  },
  observerCreator,
});

export default answerSearchResource;
